/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SearchFirmwareEquipmentModelResponse } from './search-firmware-equipment-model-response';


export interface SearchFirmwareResponse { 
    id: string;
    name: string;
    version: string;
    comment?: string | null;
    equipmentModels: Array<SearchFirmwareEquipmentModelResponse>;
    createdBy: string;
    originFileName: string;
    createdByName: string;
    createdDate: string;
}

